import { render, staticRenderFns } from "./DrinkItemDetail.vue?vue&type=template&id=48d536b2&scoped=true"
import script from "./DrinkItemDetail.vue?vue&type=script&lang=js"
export * from "./DrinkItemDetail.vue?vue&type=script&lang=js"
import style0 from "./DrinkItemDetail.vue?vue&type=style&index=0&id=48d536b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d536b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d536b2')) {
      api.createRecord('48d536b2', component.options)
    } else {
      api.reload('48d536b2', component.options)
    }
    module.hot.accept("./DrinkItemDetail.vue?vue&type=template&id=48d536b2&scoped=true", function () {
      api.rerender('48d536b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DrinkItemDetail.vue"
export default component.exports